const ItemBanner = ({src}) => {
    return (
        <div style={{display: 'grid', placeContent: 'center', backgroundColor: '#efefef'}}>
            <img
                style={{maxWidth: '100%', maxHeight: '500px', objectFit: 'contain'}}
                src={`https://academeportal-prod-storage.s3.amazonaws.com/uploads/announcement_banner/${src}`}
                alt="Laptop"
            />
        </div>
    )
}

export default ItemBanner;